<div class="bajc">
 <div class="" fxLayout="column" fxLayoutAlign="center center" *ngIf="actualizo" style="margin-top:20px">
   <div id="success"class="statusDiv" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
     <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
       <!-- <h2>{{'REQUERIMIENTOSV3.PASO3.CONTAC' | translate}}</h2> -->
       <h2>{{'REQUERIMIENTOSV3.SUCCES_CONF_EMA.MODAL_SUCCESS' | translate}} </h2>
       <mat-icon class="ml-20 s-40">check_circle</mat-icon>
     </div>
   </div>
    </div>
</div>
